import { createStore } from 'vuex'

import { createJudgeResultSocket } from './judgeResultSocket'
import { arenaModule } from './modules/arena/arenaModule'
import { postArenaSubmissionModule } from './modules/arena/postArenaSubmissionModule'
import { authStateModule } from './modules/auth/authStateModule'
import { bookmarkModule } from './modules/bookmark/bookmarkModule'
import { commentaryPageStateModule } from './modules/commentary/commentaryPageStateModule'
import { getCommentaryModule } from './modules/commentary/getCommentaryModule'
import { configStateModule } from './modules/config/configStateModule'
import { categoryRatingModule } from './modules/dashboard/categoryRatingModule'
import { courseHeatMapModule } from './modules/dashboard/courseHeatMapModule'
import { dailyEffortsModule } from './modules/dashboard/dailyEffortsModule'
import { dashboardModalStateModule } from './modules/dashboard/dashboardModalStateModule'
import { heatMapModule } from './modules/dashboard/heatMapModule'
import { howCategoryRatingModule } from './modules/dashboard/howCategoryRatingModule'
import { languageStatisticsModule } from './modules/dashboard/languageStatisticsModule'
import { programmingCategoryRatingModule } from './modules/dashboard/programmingCategoryRatingModule'
import { solvedProblemsModule } from './modules/dashboard/solvedProblemsModule'
import { statisticsModule } from './modules/dashboard/statisticsModule'
import { submissionStatusModule } from './modules/dashboard/submissionStatusModule'
import { weeklyRatingModule } from './modules/dashboard/weeklyRatingModule'
import { whatCategoryRatingModule } from './modules/dashboard/whatCategoryRatingModule'
import { editorPageStateModule } from './modules/editor/editorPageStateModule'
import { frameStateModule } from './modules/frame/frameStateModule'
import { freeSpaceJudgeDetailModule } from './modules/freeSpace/freeSpaceJudgeDetailModule'
import { freeSpaceStateModule } from './modules/freeSpace/freeSpaceStateModule'
import { historyModule } from './modules/history/historyListModule'
import { historyPageStateModule } from './modules/history/historyPageStateModule'
import { historySourceCodeModule } from './modules/history/historySourceCodeModule'
import { judgeDetailModule } from './modules/judge/judgeDetailModule'
import { judgeReferenceModule } from './modules/judge/judgeReferenceModule'
import { judgeStateModule } from './modules/judge/judgeStateModule'
import { postSubmissionModule } from './modules/judge/postSubmissionModule'
import { postTestSubmissionModule } from './modules/judge/postTestSubmissionModule'
import { recentJudgeListModule } from './modules/judge/recentJudgeListModule'
import { judgeDetailPageStateModule } from './modules/judgeDetail/judgeDetailPageStateModule'
import { modalStateModule } from './modules/modal/modalStateModule'
import { modelAnswerModule } from './modules/modelAnswer/modelAnswerListModule'
import { modelAnswerPageStateModule } from './modules/modelAnswer/modelAnswerPageStateModule'
import { modelAnswerSourceCodeModule } from './modules/modelAnswer/modelAnswerSourceCodeModule'
import {
  ArenaModuleName,
  AuthStateModuleName,
  BookmarkModuleName,
  CategoryRatingModuleName,
  ChallengeModuleName,
  CloseReviewEntryModuleName,
  CommentaryPageStateModuleName,
  ConfigStateModuleName,
  CourseHeatMapModuleName,
  CourseModuleName,
  CourseStatisticsModuleName,
  DailyEffortsModuleName,
  DashboardModalStateModuleName,
  EditorPageStateModuleName,
  FrameStateModuleName,
  FreeSpaceJudgeDetailModuleName,
  FreeSpaceStateModuleName,
  GetCommentaryModuleName,
  HeatMapModuleName,
  HistoryListModuleName,
  HistoryPageStateModuleName,
  HistorySourceCodeModuleName,
  HowCategoryRatingModuleName,
  JudgeCaseModuleName,
  JudgeDetailModuleName,
  judgeDetailPageStateModuleName,
  JudgeReferenceModuleName,
  JudgeStateModuleName,
  LanguageStatisticsModuleName,
  ModalStateModuleName,
  ModelAnswerListModuleName,
  ModelAnswerPageStateModuleName,
  ModelAnswerSourceCodeModuleName,
  NotificationModuleName,
  OpenReviewEntryModuleName,
  OpenReviewPostEntryModuleName,
  PostArenaSubmissionModuleName,
  PostReviewModuleName,
  PostSubmissionModuleName,
  PostTestSubmissionModuleName,
  ProblemDescriptionModuleName,
  ProblemSearchModalStateModuleName,
  ProblemStateModuleName,
  ProblemStatisticsModuleName,
  ProgrammingCategoryRatingModuleName,
  RecentJudgeListModuleName,
  ReviewEntryDetailModuleName,
  ReviewPageStateModuleName,
  ReviewPostEntryDetailModuleName,
  ReviewPostPageStateModuleName,
  ReviewRequestModuleName,
  SolvedProblemsModuleName,
  StatisticsModuleName,
  SubmissionStatusModuleName,
  TestCaseModuleName,
  WeeklyRatingModuleName,
  WhatCategoryRatingModuleName
} from './modules/modules'
import { notificationModule } from './modules/notification/notificationModule'
import { challengeModule } from './modules/problem/challengeModule'
import { courseModule } from './modules/problem/courseModule'
import { courseStatisticsModule } from './modules/problem/courseStatisticsModule'
import { problemDescriptionModule } from './modules/problem/problemDescriptionModule'
import { problemSearchModalStateModule } from './modules/problem/problemSearchModalStateModule'
import { problemStateModule } from './modules/problem/problemStateModule'
import { problemStatisticsModule } from './modules/problem/problemStatisticsModule'
import { reviewEntryDetailModule } from './modules/review/reviewEntryDetailModule'
import { reviewPageStateModule } from './modules/review/reviewPageStateModule'
import { openReviewPostEntryModule } from './modules/reviewPost/openReviewPostEntryModule'
import { postReviewModule } from './modules/reviewPost/postReviewModule'
import { reviewPostEntryDetailModule } from './modules/reviewPost/reviewPostEntryDetailModule'
import { reviewPostPageStateModule } from './modules/reviewPost/reviewPostPageStateModule'
import { reviewRequestModule } from './modules/reviewRequest/reviewRequestModule'
import { judgeCaseModule } from './modules/testCase/judgeCaseModule'
import { testCaseModule } from './modules/testCase/testCaseModule'

import aojWS from '@/api/aojWS'
import { createApiClients } from '@/infrastructure/clients/apiClients'
import { ArenaRepositoryImpl } from '@/infrastructure/repositories/arena/arenaRepositoryImpl'
import { AuthRepositoryImpl } from '@/infrastructure/repositories/auth/authRepositoryImpl'
import { BookmarkRepositoryImpl } from '@/infrastructure/repositories/bookmark/bookmarkRepositoryImpl'
import { CommentaryRepositoryImpl } from '@/infrastructure/repositories/commentary/commentaryRepositoryImpl'
import { DashboardRepositoryImpl } from '@/infrastructure/repositories/dashboard/dashboardRepositoryImpl'
import { HistoryRepositoryImpl } from '@/infrastructure/repositories/history/historyRepositoryImpl'
import { JudgeRepositoryImpl } from '@/infrastructure/repositories/judge/judgeRepositoryImpl'
import { ModelAnswerRepositoryImpl } from '@/infrastructure/repositories/modelAnswer/modelAnswerRepositoryImpl'
import { ProblemRepositoryImpl } from '@/infrastructure/repositories/problem/problemRepositoryImpl'
import { ReviewEntryRepositoryImpl } from '@/infrastructure/repositories/review/reviewEntryRepositoryImpl'
import { ReviewPostRepositoryImpl } from '@/infrastructure/repositories/reviewPost/reviewPostRepositoryImpl'
import { ReviewRequestRepositoryImpl } from '@/infrastructure/repositories/reviewRequest/reviewRequestRepositoryImpl'
import { SourceCodeRepositoryImpl } from '@/infrastructure/repositories/sourceCode/sourceCodeRepositoryImpl'
import { TestCaseRepositoryImpl } from '@/infrastructure/repositories/testCase/testCaseRepositoryImpl'
import { closeReviewEntryModule } from '@/store/modules/review/closeReviewEntryModule'
import { openReviewEntryModule } from '@/store/modules/review/openReviewEntryModule'

const plugin = createJudgeResultSocket(aojWS)

export type RootState = {}

export const typesEnumeration = <T extends string>(obj: { [key in T]: any }, prefix?: string) =>
  Object.keys(obj).reduce((acc, x) => ({ ...acc, [x]: prefix ? `${prefix}/${x}` : x }), {} as { [key in T]: string })

export const state: RootState = {}

const clients = createApiClients()
const authRepository = new AuthRepositoryImpl(clients)
const reviewEntryRepository = new ReviewEntryRepositoryImpl(clients)
const reviewPostRepository = new ReviewPostRepositoryImpl(clients)
const reviewRequestRepository = new ReviewRequestRepositoryImpl(clients)
const modelAnswerRepository = new ModelAnswerRepositoryImpl(clients)
const historyRepository = new HistoryRepositoryImpl(clients)
const sourceCodeRepository = new SourceCodeRepositoryImpl(clients)
const judgeRepository = new JudgeRepositoryImpl(clients)
const testCaseRepository = new TestCaseRepositoryImpl(clients)
const commentaryRepository = new CommentaryRepositoryImpl(clients)
const problemRepository = new ProblemRepositoryImpl(clients)
const bookmarkRepository = new BookmarkRepositoryImpl(clients)
const arenaRepository = new ArenaRepositoryImpl(clients)
const dashboardRepository = new DashboardRepositoryImpl(clients)

export const store = createStore({
  state,
  modules: {
    [AuthStateModuleName]: authStateModule(authRepository),
    [ConfigStateModuleName]: configStateModule(),
    [NotificationModuleName]: notificationModule(),
    [ModalStateModuleName]: modalStateModule(),
    [FrameStateModuleName]: frameStateModule(),
    [ReviewPageStateModuleName]: reviewPageStateModule(),
    [OpenReviewEntryModuleName]: openReviewEntryModule(reviewEntryRepository),
    [CloseReviewEntryModuleName]: closeReviewEntryModule(reviewEntryRepository),
    [ReviewEntryDetailModuleName]: reviewEntryDetailModule(reviewEntryRepository),
    [ReviewPostPageStateModuleName]: reviewPostPageStateModule(),
    [OpenReviewPostEntryModuleName]: openReviewPostEntryModule(reviewPostRepository),
    [PostReviewModuleName]: postReviewModule(reviewPostRepository),
    [ReviewRequestModuleName]: reviewRequestModule(reviewRequestRepository),
    [ReviewPostEntryDetailModuleName]: reviewPostEntryDetailModule(reviewEntryRepository),
    [ModelAnswerListModuleName]: modelAnswerModule(modelAnswerRepository),
    [ModelAnswerSourceCodeModuleName]: modelAnswerSourceCodeModule(sourceCodeRepository),
    [ModelAnswerPageStateModuleName]: modelAnswerPageStateModule(),
    [HistoryListModuleName]: historyModule(historyRepository),
    [HistorySourceCodeModuleName]: historySourceCodeModule(sourceCodeRepository),
    [HistoryPageStateModuleName]: historyPageStateModule(),
    [EditorPageStateModuleName]: editorPageStateModule(),
    [PostTestSubmissionModuleName]: postTestSubmissionModule(judgeRepository),
    [PostSubmissionModuleName]: postSubmissionModule(judgeRepository),
    [PostArenaSubmissionModuleName]: postArenaSubmissionModule(judgeRepository),
    [JudgeStateModuleName]: judgeStateModule(),
    [JudgeDetailModuleName]: judgeDetailModule(judgeRepository),
    [JudgeReferenceModuleName]: judgeReferenceModule(),
    [RecentJudgeListModuleName]: recentJudgeListModule(judgeRepository),
    [TestCaseModuleName]: testCaseModule(testCaseRepository),
    [JudgeCaseModuleName]: judgeCaseModule(testCaseRepository),
    [judgeDetailPageStateModuleName]: judgeDetailPageStateModule(),
    [FreeSpaceJudgeDetailModuleName]: freeSpaceJudgeDetailModule(judgeRepository),
    [FreeSpaceStateModuleName]: freeSpaceStateModule(),
    [ProblemStateModuleName]: problemStateModule(),
    [ProblemDescriptionModuleName]: problemDescriptionModule(problemRepository),
    [ProblemStatisticsModuleName]: problemStatisticsModule(problemRepository),
    [ProblemSearchModalStateModuleName]: problemSearchModalStateModule(),
    [CourseModuleName]: courseModule(problemRepository),
    [ChallengeModuleName]: challengeModule(problemRepository),
    [BookmarkModuleName]: bookmarkModule(bookmarkRepository),
    [CourseStatisticsModuleName]: courseStatisticsModule(problemRepository),
    [CommentaryPageStateModuleName]: commentaryPageStateModule(),
    [GetCommentaryModuleName]: getCommentaryModule(commentaryRepository),
    [ArenaModuleName]: arenaModule(arenaRepository),
    [StatisticsModuleName]: statisticsModule(dashboardRepository),
    [WeeklyRatingModuleName]: weeklyRatingModule(dashboardRepository),
    [CategoryRatingModuleName]: categoryRatingModule(dashboardRepository),
    [HeatMapModuleName]: heatMapModule(dashboardRepository),
    [CourseHeatMapModuleName]: courseHeatMapModule(dashboardRepository),
    [DashboardModalStateModuleName]: dashboardModalStateModule(dashboardRepository),
    [LanguageStatisticsModuleName]: languageStatisticsModule(),
    [DailyEffortsModuleName]: dailyEffortsModule(),
    [SolvedProblemsModuleName]: solvedProblemsModule(),
    [SubmissionStatusModuleName]: submissionStatusModule(),
    [WhatCategoryRatingModuleName]: whatCategoryRatingModule(),
    [HowCategoryRatingModuleName]: howCategoryRatingModule(),
    [ProgrammingCategoryRatingModuleName]: programmingCategoryRatingModule()
  },
  plugins: [plugin]
})

export const StateType = typesEnumeration(state)
